import { FARM_CONTEXT_CHANGED_EVENT } from 'farmContext';
import { useEffect } from 'react';
import {
  accountInfoQueryKey,
  getAccountInfo,
  selfDisableBoardAccess,
  selfDisableCropsAccess,
  selfDisableLspAccess,
  selfEnableBoardAccess,
  selfEnableCropsAccess,
  selfEnableLspAccess,
  setAccountFarm,
  updateAccountInfo,
} from 'api/account';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { AccountInfoData, UpdateAccountInfo } from 'types';

export const useUpdateAccountInfo = () => {

  return useMutation((params: UpdateAccountInfo) => updateAccountInfo(params));

}

export const useAccountInfo = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const onFarmContextChanged = () => {
      queryClient.invalidateQueries(accountInfoQueryKey());
    };
    window.addEventListener(FARM_CONTEXT_CHANGED_EVENT, onFarmContextChanged);
    return () => window.removeEventListener(FARM_CONTEXT_CHANGED_EVENT, onFarmContextChanged);
  }, [queryClient]);

  return useQuery<AccountInfoData>(accountInfoQueryKey(), getAccountInfo);
}

export const useSetAccountFarm = () => {

  return useMutation((farmId: string | number) => setAccountFarm(farmId));

}

export const useSelfDisableLspAccess = () => {

  return useMutation(() => selfDisableLspAccess());

}

export const useSelfDisableBoardAccess = () => {

  return useMutation(() => selfDisableBoardAccess());

}

export const useSelfDisableCropsAccess = () => {

  return useMutation(() => selfDisableCropsAccess());

}

export const useSelfEnableLspAccess = () => {

  return useMutation(() => selfEnableLspAccess());

}

export const useSelfEnableBoardAccess = () => {

  return useMutation(() => selfEnableBoardAccess());

}

export const useSelfEnableCropsAccess = () => {

  return useMutation(() => selfEnableCropsAccess());

}
